<template>
    <div id="bg">
        <div class="ios">
            <img @click="holdOn" src="../../assets/image/iosDownload.png" alt="">
            <img @click="holdOn" src="../../assets/image/androidDownload.png" alt="">
        </div>
    </div>
</template>
<script>
export default {
    methods: {
        holdOn() {
            alert("【正在开发中，即将上线】");
        }
    }
};
</script>
<style lang="scss">
#bg {
    width: 100%;
    height: 100vh;
    background: url(../../assets/image/bg.png);
    background-size: cover;
    overflow: hidden;
    .ios {
        margin-top: 480px;
        padding: 0 172px;
        text-align: left;
        img {
            width: 257px;
            height: 62px;
            &:last-of-type {
                margin-left: 66px;
            }
        }
    }
}
</style>